// extracted by mini-css-extract-plugin
export var image = "gw_dr";